export default "\r\n<svg height=\"500\" id=\"mindmap-svg\" width=\"500\" ></svg>\r\n\r\n\r\n";